import React from 'react'
import Text from '../../../Text'
import Spacer from '../../../Spacer'
import styles from './styles.module.css'

function ProductDetailsSectionHeader({ data = {} }) {
  const { title } = data

  return (
    <div>
      <Spacer size={48} />
      <div className={styles.wrapper}>
        <Text type="h4">{title}</Text>
      </div>
      <Spacer size={40} />
    </div>
  )
}

export default ProductDetailsSectionHeader
